export const transmissionToggleAction = {
  toggleFilter: (state, _action) => {
    state.isShowFilter = !state.isShowFilter;
  },
  toggleTransmissionType: (state, _action) => {
    state.transmissionType = _action.payload;
    state.isFilterToggled = true;
  },
  toggleReportType: (state, _action) => {
    state.reportType = _action.payload;
    state.isFilterToggled = true;
  },
  toggleAlert: (state, _action) => {
    state.isFilterAlert = !state.isFilterAlert;
    state.isFilterToggled = true;
  },
  togglePriorityType: (state, _action) => {
    state.priorityType = _action.payload;
  },
  toggleSavedReports: (state, _action) => {
    state.showSavedReports = !state.showSavedReports;
  },
  toggleBilledFilter: (state, _action) => {
    state.isHideBilledFilter = !state.isHideBilledFilter;
    state.isFilterToggled = true;
  },
  toggleMyPatients: (state, action) => {
    const updatePayload = Boolean(action.payload);
    const currentUserId = localStorage.getItem("userId");

    localStorage.setItem(
      `myPatientsToggled:${currentUserId}`,
      JSON.stringify(updatePayload)
    );
    state.isMyPatientsFilter = updatePayload;
  },

  clearMyPatients: (state, _action) => {
    state.isMyPatientsFilter = null;
  },
  toggleAuditedReports: (state, _action) => {
    state.showAuditedReports = !state.showAuditedReports;
  },
};
